module.exports = __webpack_public_path__ + "img/cafeamplatzfruehstueck.fcb37d4b.png";